// @ts-check
import {
  Appsettings,
  DealerInfo,
  ClientSetting,
  ContriCodesList,
  MedicalPreset,
} from "./Appsettings";
import { getUserByToken } from "./api/user";
import { getSessionToken, removeSessionToken } from "./models/users/user";
import axios from "axios";

export async function _iniciar() {
  try {
    // 1. Carga de configuraciones en paralelo
    // Extraemos .data directamente usando desestructuración para evitar el segundo Promise.all
    const [
      { data: resClientSetting },
      { data: rescountrycodes },
      { data: resappsettings },
      { data: resdealerinfo },
      { data: resmedicalPreset },
    ] = await Promise.all([
      axios.get(`/settings/clientSetting.json`),
      axios.get(`/settings/countrycodes.json`),
      axios.get(`/settings/appSettings.json`),
      axios.get(`/settings/dealerInfo.json`),
      axios.get(`/settings/medicalPresets.json`),
    ]);

    // 2. Asignación de Appsettings
    Appsettings.ApiUrl = resappsettings.apiserver;
    Appsettings.imgToDicom = resappsettings.imgToDicom;
    Appsettings.whatsappMessage = resappsettings.whatsappMessage;
    Appsettings.chunkSize = resappsettings.chunkSize || 10;
    Appsettings.cinemaLoop = resappsettings.cinemaLoop || 10;
    Appsettings.IsReady = true;
    // 3. Configuración por cliente
    ClientSetting.Theme = resClientSetting.Theme;
    ClientSetting.InstitutionName = resClientSetting.InstitutionName;
    ClientSetting.DefaultCountry = resClientSetting.defaultContriCode;
    ClientSetting.sharetime = resClientSetting.sharetime;
    ClientSetting.refNumber = resClientSetting.refNumber;

    // 4. Información del Dealer
    DealerInfo.name = resdealerinfo.name;
    DealerInfo.address = resdealerinfo.address;
    DealerInfo.phone = resdealerinfo.phone;
    DealerInfo.website = resdealerinfo.website;
    // 5. Códigos de país
    ContriCodesList.push(...rescountrycodes);
    // 6. Medical Presets
    Object.keys(resmedicalPreset).forEach((key) => {
      MedicalPreset[key] = resmedicalPreset[key];
    });

    // 6. Gestión del Token de sesión
    const token = getSessionToken();
    if (token) {
      Appsettings.ApiToken = token;
      try {
        // Intentamos validar el usuario con el token
        Appsettings.User = await getUserByToken(token);
      } catch (e) {
        // Si el token es inválido o expiró, limpiamos
        console.error("Token inválido o expirado:", e);
        removeSessionToken();
        Appsettings.ApiToken = "";
        Appsettings.User = null;
      }
    }
  } catch (error) {
    // Es vital capturar errores de carga de JSON (404, errores de red, etc.)
    console.error("Error crítico al iniciar la aplicación:", error);
    Appsettings.IsReady = false;
    throw error; // Re-lanzamos para que quien llame a _iniciar sepa que falló
  }
}

export function IsReady() {
  return Appsettings.IsReady;
}

export function IsAuth() {
  if (Appsettings.User) {
    return true;
  }
  return false;
}

export function IsMobil() {
  let toMatch = [
    /Android/i,
    /webOS/i,
    /iPhone/i,
    /iPad/i,
    /iPod/i,
    /BlackBerry/i,
    /Windows Phone/i,
  ];
  for (let i = 0; i <= toMatch.length - 1; i++) {
    if (navigator.userAgent.match(toMatch[i]) !== null) {
      return { mobil: true, os: toMatch[i].source };
    }
  }
  return { mobil: false, os: "" };
}
